import { render } from "./HomeSettingView.vue?vue&type=template&id=04650d94&scoped=true"
import script from "./HomeSettingView.vue?vue&type=script&lang=js"
export * from "./HomeSettingView.vue?vue&type=script&lang=js"

import "./HomeSettingView.vue?vue&type=style&index=0&id=04650d94&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-04650d94"]])

export default __exports__